import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { AggregateLevel } from 'src/types';
import { useMMDataContext } from '../../../contexts/MMDataContext';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { BarChart3 } from 'lucide-react';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';

type RoiProps = {
  aggregateLevel: AggregateLevel;
};

export const Roi: React.FC<RoiProps> = ({ aggregateLevel }) => {
  const { roi } = useMMDataContext();

  const keyMetricData: KeyMetricData = useMemo(() => {
    return {
      isLoading: roi.isLoading,
      isError: roi.isError,
      name: 'ROI',
      isEuro: false,
      summaryValue: roi.total,
      data: getAggregateLevelData(roi, aggregateLevel),
    };
  }, [roi, aggregateLevel]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      title="ROI"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={keyMetricData.isLoading}
      isError={keyMetricData.isError}
      icon={<ChakraIcon as={BarChart3} boxSize={5} color="gray.500" />}
    />
  );
};
